const translations = {
  title: 'Integrações',
  name: 'Nome',
  service: 'Serviço',
  createdAt: 'Criado em',
  updatedAt: 'Atualizado em',
  actions: 'Ações',
  modalTitle: 'Criar nova Integração',
  newIntegration: 'Nova Integração',
  selectAccount: 'Selectione a conta',
  newIntegrationWithService: 'Nova Integração: {{service}}',
  tokenIntegrationDescription:
    'O {{service}} não suporta integração por redirecionamento e login. É necessário copiar o(s) token(s) de integração na plataforma do {{service}} e colar no formulário abaixo:',
  select: 'Selecionar',
  'widgets.segware.name': 'Integração com Segware',
  'widgets.segware.description': 'Criar integração com a Segware',
  'widgets.twilio.name': 'Integração com twilio',
  'widgets.twilio.description': 'Criar integração com o Twilio',
  'widgets.chat_pro.name': 'Integração com ChatPro',
  'widgets.chat_pro.description': 'Criar integração com o ChatPro',
  'widgets.slack.name': 'Integração com Slack',
  'widgets.slack.description': 'Criar integração com o Slack',
  'widgets.google.name': 'Integração com Google Calendar',
  'widgets.google.description': 'Criar integração com o Google Calendar',
  'widgets.d4sign.name': 'Integração com d4sign',
  'widgets.d4sign.description': 'Criar integração com o D4sign',
  'segware.companyId': 'Company ID*',
  'segware.bearerToken': 'Bearer Token*',
  'd4sign.tokenApi': 'Token Api*',
  'd4sign.cryptKey': 'Crypt Key*',
  'twilio.accountSid': 'Account SID*',
  'twilio.authToken': 'Auth Token*',
  'twilio.myTwilioPhone': 'Meu telefone twilio*',
  'chat_pro.name': 'Nome da integração*',
  'chat_pro.instanceId': 'Código da instância*',
  'chat_pro.instanceToken': 'Chave da API*'
}

export default translations
